var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "remember-container" },
    [
      _c("HeaderComponent"),
      _c(
        "section",
        { staticClass: "remember-content" },
        [_c("LoginFormComponent")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }